import request from '@/utils/request'

/**
 * 得到所有需要配置的模板短链接列表
 */
export function getTemplateListTerm() {
  return request({
    method: 'GET',
    url: 'yia/v1/template/list-term'
  })
}

/**
 * 得到这个公众号已配置的模板id列表
 */
export function getTemplateList(accountId) {
  return request({
    method: 'GET',
    url: `yia/v1/template/list/${accountId}`
  })
}

/**
 * 根据模板类型（服务器根据模板类型自动获取对应的短id）获取最终配置的长id
 */
export function getTemplateIdByHisType(path, hisType) {
  return request({
    method: 'GET',
    url: `yia/v1/wx/client/${path}/getTemplateId`,
    params: {
      hisType
    }
  })
}

/**
 * 保存模板类型与长id的关系表
 */
export function saveHisTypeTemplateIdContact(data) {
  return request({
    method: 'POST',
    url: 'yia/v1/template/save',
    data
  })
}

/**
 * 删除微信后台模板
 */
export function delTemplateId(path, templateId) {
  return request({
    method: 'GET',
    url: `yia/v1/wx/client/${path}/delTemplateId`,
    params: {
      templateId
    }
  })
}
